class Util {
    /**
     * 获取指定对象的指定属性
     * @param {Object} data JSON数据
     * @param {String} strField 要获取JSON数据的属性名层级字符串
     * @param {any} pattern 类型判断，不传时返回值
     */
    getField(data, strField, pattern) {
        var arr = strField.split(".");
        var key = arr.shift();
        var value = data[key];

        if (value == null) {
            return value;
        } else if (arr.length == 0) {
            if (!pattern) return value;
            var type = Object.prototype.toString
                .call(value)
                .replace("[object ", "")
                .replace("]", "");
            if (pattern === true) {
                return type;
            } else if (!pattern) {
                return value;
            } else {
                return type == pattern;
            }
        }
        var result = objFunc.getField(value, arr.join("."), pattern);
        return result;
    }

    /**
     * 设置指定对象的指定属性
     * @param {Object} data JSON数据
     * @param {String} strField 要设置JSON数据的属性名层级字符串
     * @param {string} newVal 值
     */
    setField(data, strField, newVal) {
        var arr = strField.split(".");
        var key = arr.shift();
        var value = data[key];

        if (value == null) {
            return value;
        } else if (arr.length == 0) {
            data[key] = newVal;
        }

        var result = objFunc.setField(value, arr.join("."), newVal);
        return result;
    }

    /**
     * 本地持久性存储
     * @param {String} table 表名
     * @param {Object} settings 存储的对象，传入 remove: true 删除
     * @param {*} storage 
     * @link https://gitee.com/sentsin/layui/blob/master/src/layui.js?_from=gitee_search
     */
    localStorage(table, settings, storage) {
        table = table || 'layui';
        storage = storage || localStorage;

        if (!window.JSON || !window.JSON.parse) return;

        //如果settings为null，则删除表
        if (settings === null) {
            return delete storage[table];
        }

        settings = typeof settings === 'object' ?
            settings : {
                key: settings
            };

        try {
            var data = JSON.parse(storage[table]);
        } catch (e) {
            var data = {};
        }

        if ('value' in settings) data[settings.key] = settings.value;
        if (settings.remove) delete data[settings.key];
        storage[table] = JSON.stringify(data);

        return settings.key ? data[settings.key] : data;
    }

    /**
     * 本地会话性存储
     * @param {*} table 表名
     * @param {*} settings 存储的对象，传入 remove: true 删除
     */
    sessionStorage(table, settings) {
        return this.localStorage(table, settings, sessionStorage);
    }
    /**
     * 获取指定Url的Location
     * @param {string} url url地址
     */
    getUrlLocation(url) {
        var location = {};

        location.href = url;
        location.protocol = url.split("//")[0];
        location.hash = url.split("#")[1];
        location.host = url.split("//")[1].split('/')[0];
        location.pathname = url.split("//")[1].split('#')[0].split('?')[0].replace(location.host, "");
        location.method = location.pathname.split(".")[0];

        return location;
    }
}


export default new Util();